import classnames from 'classnames';
import ChevronIcon from 'components/icons/ChevronIcon';
import React from 'react';

import CarouselButton, { CarouselButtonProps } from './CarouselButton';

const CSS = require('./SideButtons.module.scss');

type PreviousButtonProps = {
  disabled?: boolean;
  onClick: (e: any) => void;
  isInverted?: boolean;
} & Omit<CarouselButtonProps, 'children'>;

function PreviousButton({
  disabled,
  onClick,
  isInverted,
  ...rest
}: PreviousButtonProps) {
  return (
    <CarouselButton
      disabled={disabled}
      onClick={onClick}
      aria-label="Previous"
      isInverted={isInverted}
      {...rest}
    >
      <ChevronIcon
        direction="left"
        width={9}
        height={15}
        className={classnames(CSS.PreviousChevronIcon, {
          [CSS.DisabledIcon]: disabled,
          [CSS.InvertedIcon]: isInverted,
        })}
      />
    </CarouselButton>
  );
}

export default PreviousButton;
